<template>
  <!-- Render Nav component for all routes except '/welcome' -->
  <template v-if="!excludedPaths.includes(route.path)">
    <NavBar />
  </template>
  <RouterView />

</template>

<script setup>
import { onMounted, watch, onBeforeMount } from 'vue';
import { useRoute, useRouter } from "vue-router";
import NavBar from '@/components/NavBar.vue';
import { useSkippedModulesStore } from '@/stores/skippedModules';

// Define the paths where NavBar should not be shown
const excludedPaths = ['/login', '/sign-up', '/forgot-password', '/new_password', '/payment', '/subscription/success', '/onboarding/welcome', '/onboarding/organization', '/onboarding/', '/onboarding/about-you', /* '/onboarding/self-assessment', */ '/onboarding/team' ];

const route = useRoute();
const router = useRouter();
const skippedModulesStore = useSkippedModulesStore();

// Handle pending-redirect-cleared events
const handlePendingRedirect = (event) => {
  const { path } = event.detail;
  if (path && path !== route.path) {
    // Navigate using Vue Router to avoid page refresh
    router.replace(path);
  }
};

// Check for any pending redirects or skip operations on load
onBeforeMount(() => {
  // Check if we need to handle any pending redirects
  const pendingRedirect = localStorage.getItem('pendingRedirect');
  if (pendingRedirect) {
    // Clear the flag
    localStorage.removeItem('pendingRedirect');
    
    // If we're not already on the target page, redirect using Vue Router
    if (pendingRedirect !== route.path) {
      router.replace(pendingRedirect);
    }
  }
  
  // Initialize the skipped modules state
  skippedModulesStore.checkSkipState();
  
  // Add event listener for pending redirect events
  window.addEventListener('pending-redirect-cleared', handlePendingRedirect);
});

// Apply styles conditionally when the component is mounted or route changes
const applyStyles = () => {
  if (!excludedPaths.includes(route.path)) {
    document.body.classList.add("bg-[#00423D]", "px-4", "pb-4");
  } else {
    document.body.classList.remove("bg-[#00423D]", "px-4", "pb-4");
  }
};

// Run when the component is mounted
onMounted(() => {
  applyStyles();
  
  // Force refresh skipped modules
  skippedModulesStore.fetchSkippedModules(true);
});

// Watch for route changes and apply styles accordingly
watch(() => route.path, () => {
  applyStyles();
});
</script>

<style>

</style>
